import React from 'react';
import Icon from '../../design-system/icon.jsx';

export const Header = ({ count, onCloseCart }) => (
  <div className="cart-popup__header">
    <div className="cart-popup__header-text">
      <b>Cart</b>
      {count > 0 && (
        <div className="cart-popup__header-count">
          {count}
        </div>
      )}
    </div>
    <span
      className="cart-popup__header-icon cart-popup__header-icon--close"
      role="button"
      onClick={onCloseCart}
    >
      <Icon type="close" />
    </span>
  </div>
);
